import type { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import React from "react";

import type { DownloadAsset } from "../../types/common";
import type { InsightPreviewFileFormats } from "../../types/insightPreviewFileFormats";
import { isMediaFile } from "../../utils/insightPreview.utils";

import { MediaViewer } from "./MediaViewer";
import { PdfSelectionViewer } from "./PdfSelectionViewer";

export interface InsightViewerProps {
    previewFileFormat: InsightPreviewFileFormats;
    previewAsset?: DownloadAsset;
    numPages: number;
    setNumPages: (e: any) => void;
    insightType: InsightType;
    identifier: string;
    selectedSlides?: Set<number>;
    setSelectedSlides?: (selectedslides: Set<number>) => void;
    isCompliant?: boolean;
}

export const InsightViewer: React.FunctionComponent<InsightViewerProps> = (
    props: InsightViewerProps,
) => {
    const {
        previewFileFormat,
        previewAsset,
        numPages,
        setNumPages,
        insightType,
        identifier,
        selectedSlides = new Set(),
        setSelectedSlides = () => {},
        isCompliant = true,
    } = props;

    return (
        <div data-testid="insight-viewer-container">
            {isMediaFile(previewFileFormat) ? (
                <MediaViewer
                    fileFormat={previewFileFormat}
                    previewAsset={previewAsset!}
                />
            ) : (
                <PdfSelectionViewer
                    numPages={numPages}
                    setNumPages={setNumPages}
                    url={previewAsset?.downloadUrl ?? ""}
                    insightType={insightType}
                    identifier={identifier}
                    selectedSlides={selectedSlides}
                    setSelectedSlides={setSelectedSlides}
                    isCompliant={isCompliant}
                />
            )}
        </div>
    );
};
